:host {
  pointer-events: none;
  overflow: hidden;
}

:host(:not([stretch-off])) {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
